"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftExtend = require("draft-extend");

var _constants = require("composer-plugins/lib/constants");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _embedDataToHtml = _interopRequireDefault(require("rich-text-lib/utils/embedDataToHtml"));

var _embed = require("rich-text-lib/constants/embed");

var _htmlToEmbedData = _interopRequireDefault(require("rich-text-lib/utils/htmlToEmbedData"));

var _EmbedComponent = _interopRequireDefault(require("./EmbedComponent"));

var BLOCK_TYPE = 'atomic';

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$embedButtonB = options.embedButtonBuilder,
      embedButtonBuilder = _options$embedButtonB === void 0 ? function () {
    return null;
  } : _options$embedButtonB,
      _options$useUnstyledB = options.useUnstyledButton,
      useUnstyledButton = _options$useUnstyledB === void 0 ? false : _options$useUnstyledB;

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (!(0, _draftHelpers.isCorrectBlockTypeAndSize)(currentBlock, BLOCK_TYPE)) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (entity && entity.getType() === _constants.ENTITY_TYPES.embed) {
        return {
          component: _EmbedComponent.default,
          editable: false,
          props: props
        };
      }

      return undefined;
    };
  };

  var htmlToEntity = function htmlToEntity(nodeName, node, createEntity) {
    if (nodeName !== _embed.embedTypes.AUDIO && nodeName !== _embed.embedTypes.EMBED && nodeName !== _embed.embedTypes.IFRAME && nodeName !== _embed.embedTypes.OBJECT && nodeName !== _embed.embedTypes.VIDEO) {
      return undefined;
    }

    return createEntity(_constants.ENTITY_TYPES.embed, 'IMMUTABLE', (0, _htmlToEmbedData.default)(node.outerHTML));
  };

  var entityToHTML = function entityToHTML(entity) {
    if (entity.type !== _constants.ENTITY_TYPES.embed) {
      return undefined;
    }

    return "<div class= \"" + _constants.EMBED_COMPONENT_CLASSNAME + "\">\n        " + (0, _embedDataToHtml.default)(entity.data) + "\n      </div>";
  };

  var htmlToBlock = function htmlToBlock(nodeName) {
    if (nodeName === 'iframe') {
      return BLOCK_TYPE;
    }

    return undefined;
  };

  return (0, _draftExtend.createPlugin)({
    buttons: embedButtonBuilder(useUnstyledButton),
    blockRendererFn: blockRendererFn(options),
    htmlToEntity: htmlToEntity,
    entityToHTML: entityToHTML,
    htmlToBlock: htmlToBlock
  });
};

exports.default = _default;
module.exports = exports.default;